import { cx } from "@emotion/css";
import type { LucideIcon } from "lucide-react";
import { CircleHelp, FileText, Fish } from "lucide-react";
import { useTranslation } from "react-i18next";
import type { SearchType } from "src/api/search";
import { OutlinedTextBlackButton } from "src/components/Default/LekUI/Button";

const TYPE_ICONS: Record<SearchType, LucideIcon> = {
	questions: CircleHelp,
	articles: FileText,
	decks: Fish,
};

type SearchEmptyStateProps = {
	type: SearchType;
	searchValue: string;
	onClearFilters: () => void;
};

// pusta lista wyników na stronie szukajki — ikona w kolorze typu, tytuł z frazą, podpowiedź i „Wyczyść filtry”
export function SearchEmptyState({
	type,
	searchValue,
	onClearFilters,
}: SearchEmptyStateProps) {
	const { t } = useTranslation();
	const Icon = TYPE_ICONS[type];

	return (
		<div className="search-empty" data-test-id={`search-empty-${type}`}>
			<span className={cx("search-empty__icon", `search-type--${type}`)}>
				<Icon className="icon-big" />
			</span>
			<h3 className="search-empty__title">
				{searchValue
					? t(`search.empty.${type}.titlePhrase`, { phrase: searchValue })
					: t(`search.empty.${type}.title`)}
			</h3>
			<p className="search-empty__description">
				{t(`search.empty.${type}.description`)}
			</p>
			<div className="search-empty__actions">
				<OutlinedTextBlackButton
					onClick={onClearFilters}
					data-test-id="search-empty-clear-filters"
				>
					{t("search.empty.clearFilters", "Wyczyść filtry")}
				</OutlinedTextBlackButton>
			</div>
		</div>
	);
}
